

import React from 'react';
import '../css/SkillDevelopment.css';

function SkillDevelopment() {
  return (
    <section className="course-detail">
      
      <h2 style={{textAlign:'center'}}>Skill Development Program</h2>
      <p>This fee-less course is offered by the Ministry of HRD, Government of India. It is tailor-made for class 8th pass, skilled, semi-skilled, or unskilled aspirants. The program includes:</p>
      <ul>
        <li>HSRT (Hospitality Skill Recognition Test)</li>
        <li>Skill Certification</li>
        <li>Guide Training</li>
        <li>Cooks Training</li>
        <li>Steward Training</li>
      </ul>
      <p>These short-term programs help participants gain employment or upskill in the hospitality sector.</p>
      <ul>
        <li><b>Duration:</b> Short-term (varies by program)</li>
        <li><b>Eligibility:</b> 8th pass and above</li>
        <li><b>Career Opportunities:</b> Entry-level jobs, upskilling, certification</li>
      </ul>
      <div style={{background:'#f4f8fb',padding:'1.2rem',borderRadius:'8px',marginTop:'2rem',boxShadow:'0 1px 8px rgba(20,55,90,0.06)'}}>
        <b>Read More:</b><br/><br/>
        The Skill Development Program at Food Craft Institute Sumerpur is a unique initiative aimed at empowering youth and adults with practical skills for immediate employment in the hospitality sector. The curriculum is designed in collaboration with industry partners and focuses on hands-on training, workplace readiness, and soft skills development. <br/><br/>
        Participants benefit from expert trainers, modern facilities, and real-world exposure through internships and live projects. The program is inclusive, accessible, and flexible, catering to the needs of diverse learners. Graduates receive government-recognized certification, opening doors to a wide range of job opportunities in hotels, restaurants, tourism, and allied industries. <br/><br/>
        Whether you are looking to start a new career, upskill, or gain formal recognition for your existing skills, the Skill Development Program at FCI Sumerpur provides a solid foundation for success in the dynamic world of hospitality.
      </div>
    </section>
  );
}

export default SkillDevelopment;
